import React, { useState } from "react";
import { DynamicRankmiDashboard } from "@rankmi/dashboard-app";
import AreaFilter from "../../area_filter/AreaFilter";
import { organizationDashboardFilters } from "../../dashboardFilters";

const SelectionProcessReport = ({
  idDashboard,
  enterpriseToken,
  organizationDomainToken = null,
}) => {
  const [areasSelected, setAreasSelected] = useState(null);

  const onChangeArea = (area) => {
    setAreasSelected(area.token);
  };
  const filters = {
    enterprise_token: [enterpriseToken],
    ...organizationDashboardFilters(organizationDomainToken),
    ...(areasSelected ? { parent_area: [areasSelected] } : {}),
  };

  return (
    <div className="SelectionProcessReport">
      <AreaFilter onChangeArea={onChangeArea} />
      <DynamicRankmiDashboard
        key={`${idDashboard}-${organizationDomainToken || "default"}-${areasSelected || "default"}`}
        dashboard={idDashboard}
        product={"rkm_14"}
        filters={filters}
      />
    </div>
  );
};

export default SelectionProcessReport;
